module.exports = __webpack_public_path__ + "static/media/Cooked_Mandrake.59b5049b.webp";